import React from "react";

const TotalSummary = (props) => {
    const {totalinfo} = props;
    const {totalcontacts} = props;
    return(
        <div className="summary-blocks">
            <h2>Total</h2>
            <div className="record-details">
                <ul className="colored-record">
                    <li className="row-grey">
                        <div className="row-data">{totalcontacts}</div>
                        <div className="data-percent"></div>
                        <div className="data-label">Recipients</div>
                    </li>
                    <li className="row-grey">
                        <div className="row-data">{totalinfo?.sent?.count}</div>
                        <div className="data-percent">{totalinfo?.sent?.percentage}%</div>
                        <div className="data-label">Sent</div>
                    </li>
                    <li className={(props?.messageType === 'text/plain' || !props.trackOpen) ? 'row-grey opacity-30':'row-grey'}>
                        <div className="row-data">{totalinfo?.open?.count}</div>
                        <div className="data-percent">{totalinfo?.open?.percentage}%</div>
                        <div className="data-label">Opened</div>
                    </li>
                    <li className={(props?.messageType === 'text/plain' || !props.trackClicks) ? 'row-grey opacity-30':'row-grey'}>
                        <div className="row-data">{totalinfo?.click?.count}</div>
                        <div className="data-percent">{totalinfo?.click?.percentage}%</div>
                        <div className="data-label">Clicked</div>
                    </li>
                    <li className="row-grey">
                        <div className="row-data">{totalinfo?.reply?.count}</div>
                        <div className="data-percent">{totalinfo?.reply?.percentage}%</div>
                        <div className="data-label">Replied</div>
                    </li>
                    <li className="row-grey">
                        <div className="row-data">{totalinfo?.bounce?.count}</div>
                        <div className="data-percent">{totalinfo?.bounce?.percentage}%</div>
                        <div className="data-label">Bounced</div>
                    </li>
                    <li className="row-grey">
                        <div className="row-data">{totalinfo?.unsubscribe?.count}</div>
                        <div className="data-percent">{totalinfo?.unsubscribe?.percentage}%</div>
                        <div className="data-label">Unsubscribed</div>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default TotalSummary;